export default __webpack_public_path__ + "static/media/fureverhomes4.2cc8b3b5.png";